import { createStyles, makeStyles } from '@material-ui/core';
import { variables } from '../../../styles';

export const useStyles = makeStyles(() =>
  createStyles({
    option: {
      '& span': {
        marginInlineStart: 20,
      },
      '& svg path': {
        stroke: variables.black10,
      },
    },
    selectedOption: {
      '& svg path': {
        stroke: variables.richBlack,
      },
      '& span': {
        marginInlineStart: 20,
      },
    },
    multiSelect: {
      width: 178,
      margin: 0,
      marginInlineEnd: 5,
      borderRadius: 10,
      boxShadow: 'none',

      '& fieldset': {
        border: '1px solid #0000003b',
      },

      '@media (max-width: 1180px)': {
        width: 170,
        fontSize: 13,
        height: 40,
        borderRadius: 6,
      },

      '@media (max-width: 410px)': {
        width: 148,
        fontSize: 13,
        height: 40,
        minWidth: 'unset !important',
        marginTop: 8,
        borderRadius: 6,
      },
    },
    columns: {
      marginInlineStart: 'auto',

      '@media (max-width: 1025px)': {
        marginInlineStart: 0,
      },
    },
    dialog: {
      width: 343,
      borderRadius: 16,
      padding: '16px 32px 32px 32px',
    },
    desktopContainer: {
      '@media (max-width: 1180px)': {
        display: 'none',
      },
    },
    mobileContainer: {
      '@media (min-width: 1181px)': {
        display: 'none',
      },
    },
  }),
);
